import request from '@/utils/request';
import getData from './axios';
export function login(data) {
  // return request({
  //   url: '/vue-admin-template/user/login',
  //   method: 'post',
  //   data
  // })
  return getData({
    url: 'oauth/userLogin',
    method: 'POST',
    data: data,
    params: data,
    noToken: true
  });
}
export function tokenlogin(data) {
  return getData({
    url: 'oauth/tokenInfo',
    method: 'POST',
    data: data,
    noToken: true
  });
}
export function refreshToken(data) {
  return getData({
    url: 'oauth/refreshToken',
    method: 'POST',
    data: data,
    params: data,
    noToken: true
  });
}
export function getInfo(token) {
  return request({
    url: '/vue-admin-template/user/info',
    method: 'get',
    params: {
      token: token
    }
  });
}
export function logout() {
  return getData({
    url: 'oauth/logout',
    method: 'DELETE'
  });
}